import ipad from 'marketing-website/media/images/pages/sketchpad/ipad@2x.png';
import iphone4 from 'marketing-website/media/images/pages/sketchpad/iphone4@2x.png';
import iphone5 from 'marketing-website/media/images/pages/sketchpad/iphone5@2x.png';
import iphone6 from 'marketing-website/media/images/pages/sketchpad/iphone6@2x.png';
import iphone6Plus from 'marketing-website/media/images/pages/sketchpad/iphone6plus@2x.png';
import nexus5 from 'marketing-website/media/images/pages/sketchpad/nexus5@2x.png';

const assets = {
  ipad: {
    alt: 'iPad printable sketch paper preview',
    src: ipad,
    maxWidth: 421,
    hasShadow: false,
  },
  iphone4: {
    alt: 'iPhone 4 printable sketch paper preview',
    src: iphone4,
    maxWidth: 421,
    hasShadow: false,
  },
  iphone5: {
    alt: 'iPhone 5 printable sketch paper preview',
    src: iphone5,
    maxWidth: 421,
    hasShadow: false,
  },

  iphone6: {
    alt: 'iPhone 6 printable sketch paper preview',
    src: iphone6,
    maxWidth: 421,
    hasShadow: false,
  },

  iphone6Plus: {
    alt: 'iPhone 6 Plus printable sketch paper preview',
    src: iphone6Plus,
    maxWidth: 421,
    hasShadow: false,
  },

  nexus5: {
    alt: 'Nexus 5 printable sketch paper preview',
    src: nexus5,
    maxWidth: 421,
    hasShadow: false,
  },
};

export default assets;



// WEBPACK FOOTER //
// ./src/configs/pages/sketchpad/assets.js